import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.episode-meta-icon {
  font-size: 16px;
  background: #ededed;
  color: ${colors.midGrey2};
  display: inline-block;
  font-weight: bold;
  height: 26px;
  line-height: 30px;
  margin-right: .5em;
  margin-bottom: .5em;
  text-align: center;
  text-transform: uppercase;
  width: 26px;
  border-radius: 3px;
  border-bottom: solid 2px #dadada;
}
.episode-icons{
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.is-guidance-or-info {
  background: ${colors.red};
  border-color: ${colors.darkRed};
  color: ${colors.white};
}
`
